import api from '@/services/api/api';

export const useNews = (
  params = {
    page: 1,
    filters: {},
  },
) => {
  const news = useInfiniteQuery(
    ['news', params.filters, params.page],
    async ({ pageParam = toValue(params.page) }) => {
      const { data } = await api.news.getNews(
        {
          per_page: params.per_page,
          page: pageParam,
          isMainPage: params.isMainPage || false,
        },
        toValue(params.filters),
      );

      return data;
    },
    {
      staleTime: Infinity,
      select: ({ pages }) => ({
        meta: pages[pages.length - 1].meta,
        data: pages.flatMap((data) => data.data),
      }),
      getNextPageParam: (data) => {
        return data.meta.current_page < data.meta.last_page
          ? data.meta.current_page + 1
          : undefined;
      },
      refetchOnMount: true,
      keepPreviousData: true,
    },
  );

  const queryClient = useQueryClient();

  const resetPage = (filters) => {
    queryClient.setQueryData(['news', filters], (prevData) => {
      if (!prevData) return;
      return {
        pages: [prevData.pages[0]],
        pageParams: [prevData.pageParams[0]],
      };
    });
  };

  onServerPrefetch(async () => {
    await news.suspense();
  });

  return {
    news,
    resetPage,
  };
};
